export default __webpack_public_path__ + "static/media/category_2.0a155dc3.png";